import { getLastRelease } from '../../../releases';
import { Typography } from '../typography/typography';
import { Tooltip } from '../tooltip/tooltip';
import { navMenuFooter } from './navMenu.css';
import { useBreakpoints } from '@design-system/breakpointsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons';

export type NavMenuFooterProps = {
  onLogout: () => void;
};

export const NavMenuFooter = (p: NavMenuFooterProps) => {
  const isTablet = useBreakpoints((s) => s.tablet);
  const v = getLastRelease();

  return (
    <footer className={navMenuFooter}>
      {isTablet ? (
        <div role="button" onClick={p.onLogout}>
          <FontAwesomeIcon icon={faArrowRightFromBracket} color="inherit" />
        </div>
      ) : (
        <>
          <div role="button" onClick={p.onLogout}>
            <Typography variant="body" size="medium" as="span" color="N-60">
              Log out
            </Typography>
          </div>
          <Tooltip
            arrow
            variant="light"
            title={v.date.toDateString() + ': ' + v.notes}
          >
            <Typography variant="body" size="small" as="span">
              Version {v.version}
            </Typography>
          </Tooltip>
        </>
      )}
    </footer>
  );
};
